import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { MatSnackBar } from '@angular/material';
import * as firebase from 'firebase';

const LOADING_IMAGE_URL = 'https://www.google.com/images/spin-32.gif';
const PROFILE_PLACEHOLDER_IMAGE_URL = '/assets/images/profile_placeholder.png';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'List',
      url: '/list',
      icon: 'list'
    }
  ];


user: Observable<firebase.User>;
  currentUser: firebase.User;
  messages: Observable<any[]>;
  message:any;
  profilePicStyles: {};
  topics = '';
  value = '';
   showEmojiPicker = false;
  showGiphySearch= false;
  date=Date();
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public db: AngularFireDatabase, public afAuth: AngularFireAuth, public snackBar: MatSnackBar
  ) {
    this.initializeApp();

     this.user = afAuth.authState;
    this.user.subscribe((user: firebase.User) => {
      console.log(user);
      console.log(this.date);
      this.currentUser = user;

      if (user) { // User is signed in!
        this.profilePicStyles = {
          'background-image':  `url(${this.currentUser.photoURL})`
        };

        // We load currently existing chat messages.
        this.messages = this.db.list<any>('/messages', ref => ref.limitToLast(180)).valueChanges();
        this.messages.subscribe((messages) => {
          // Calculate list of recently discussed topics
          const topicsMap = {};
          const topics = [];
          let hasEntities = false;
          messages.forEach((message) => {
            if (message.entities) {
              for (let entity of message.entities) {
                if (!topicsMap.hasOwnProperty(entity.name)) {
                  topicsMap[entity.name] = 0
                }
                topicsMap[entity.name] += entity.salience;
                hasEntities = true;
              }
            }
          });
          if (hasEntities) {
            for (let name in topicsMap) {
              topics.push({ name, score: topicsMap[name] });
            }
            topics.sort((a, b) => b.score - a.score);
            this.topics = topics.map((topic) => topic.name).join(', ');
          }

          // Make sure new message scroll into view
          setTimeout(() => {
            const messageList = document.getElementById('messages');
            messageList.scrollTop = messageList.scrollHeight;
            document.getElementById('message').focus();
          }, 500);
        });

        // We save the Firebase Messaging Device token and enable notifications.
        this.saveMessagingDeviceToken();
      } else { // User is signed out!
        this.profilePicStyles = {
          'background-image':  PROFILE_PLACEHOLDER_IMAGE_URL
        };
        this.topics = '';
      }
    });

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  
        toggleEmojiPicker() {
          console.log("emoji show");
        this.showEmojiPicker = !this.showEmojiPicker;
        console.log( this.showEmojiPicker);
      }
 toggleGiphySearch() {
    this.showGiphySearch = !this.showGiphySearch;
  }
  addEmoji(event) {
        const { message } = this;
        let text;
        if(message==undefined){
           text = `${event.emoji.native}`;
        }
        else{
           text = `${message}${event.emoji.native}`;
        }
        

        this.message = text;
        //this.showEmojiPicker = false;
      }


  login() {
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  // TODO: Refactor into text message form component
  update(value: string) {
    this.value = value;
  }

  // Returns true if user is signed-in. Otherwise false and displays a message.
  checkSignedInWithMessage() {
    // Return true if the user is signed in Firebase
    if (this.currentUser) {
      return true;
    }

    this.snackBar
      .open('You must sign-in first', 'Sign in', {
        duration: 5000
      })
      .onAction()
      .subscribe(() => this.login());

    return false;
  };

  // TODO: Refactor into text message form component
  saveMessage(event: any, el: HTMLInputElement) {
    event.preventDefault();

    if (this.value && this.checkSignedInWithMessage()) {
      // Add a new message entry to the Firebase Database.
      const messages = this.db.list('/messages');
      messages.push({
        name: this.currentUser.displayName,
        text: this.value,
        time: Date(),
        photoUrl: this.currentUser.photoURL || PROFILE_PLACEHOLDER_IMAGE_URL
      }).then(() => {
        // Clear message text field and SEND button state.
        el.value = '';
        this.message = '';
      }, (err) => {
        console.log(err);
        this.snackBar.open('Error writing new message to Firebase Database.', null, {
          duration: 5000
        });
        console.error(err);
      });
    }
  }

  // TODO: Refactor into image message form component
  saveImageMessage(event: any) {
    console.log("sending message");
    event.preventDefault();
    const file = event.target.files[0];
    console.log(file);

    // Clear the selection in the file picker input.
    const imageForm = <HTMLFormElement>document.getElementById('image-form');
    imageForm.reset();

    // Check if the file is an image.
    if (!file.type.match('image.*')) {
      this.snackBar.open('You can only share images', null, {
        duration: 5000
      });
      return;
    }

    // Check if the user is signed-in
    if (this.checkSignedInWithMessage()) {
        let user=this.currentUser;
      // We add a message with a loading icon that will get updated with the shared image.
      const messages = this.db.list('/messages');
      let filePath = `${this.currentUser.uid}/${file.name}`;
      let uploadTask =firebase.storage().ref(filePath).put(file)
         uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) =>  {
          console.log(uploadTask.snapshot);

        // upload in progress
        //upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      },
      (error) => {
        // upload failed
        console.log(error);
      },
      () => {
         console.log("success");
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);

         
        // upload success
       
        let filename = file.name
        //this.saveFileData(upload)
          messages.push({
        name: user.displayName,
        filename: filename,
        imageUrl: downloadURL,
        time: Date(),
        photoUrl: user.photoURL || PROFILE_PLACEHOLDER_IMAGE_URL
      });
  });
       
      }
    );
    
      // .then((data) => {
      //   // Upload the image to Cloud Storage.
      //   const filePath = `${this.currentUser.uid}/${data.key}/${file.name}`;
      //   return firebase.storage().ref(filePath).put(file)
      //     .then((snapshot) => {
      //       console.log(snapshot);
      //       // Get the file's Storage URI and update the chat message placeholder.
      //       const fullPath = snapshot.metadata.fullPath;
      //       const imageUrl = firebase.storage().ref(fullPath).toString();
      //        console.log(imageUrl);
      //       return firebase.storage().refFromURL(imageUrl).getMetadata();
      //     }).then((metadata) => {
      //       console.log(metadata);
      //       console.log(metadata.downloadURLs[0]);
      //       // TODO: Instead of saving the download URL, save the GCS URI and
      //       //       dynamically load the download URL when displaying the image
      //       //       message.
      //       return data.update({
      //         imageUrl: metadata.downloadURLs[0]
      //       });
      //     },
      //     (err) => {
      //       console.log(err);
      //       this.snackBar.open('There was an error uploading a file to Cloud Storage. 2', null, {
      //     duration: 5000
      //   });
      //   console.log(err);
      //     });
      // }).then(console.log, (err) => {
      //   console.log(err);
      //   this.snackBar.open('There was an error uploading a file to Cloud Storage. 1', null, {
      //     duration: 5000
      //   });
        
      // });
    }
  }

  // TODO: Refactor into image message form component
  onImageClick(event: any) {
    event.preventDefault();
    document.getElementById('mediaCapture').click();
  }

  // Saves the messaging device token to the datastore.
  saveMessagingDeviceToken() {
    return firebase.messaging().getToken()
      .then((currentToken) => {
        if (currentToken) {
          console.log('Got FCM device token:', currentToken);
          // Save the Device Token to the datastore.
          firebase.database()
            .ref('/fcmTokens')
            .child(currentToken)
            .set(this.currentUser.uid);
        } else {
          // Need to request permissions to show notifications.
          return this.requestNotificationsPermissions();
        }
      }).catch((err) => {
        this.snackBar.open('Unable to get messaging token.', null, {
          duration: 5000
        });
        console.error(err);
      });
  };

  // Requests permissions to show notifications.
  requestNotificationsPermissions() {
    console.log('Requesting notifications permission...');
    return firebase.messaging().requestPermission()
      // Notification permission granted.
      .then(() => this.saveMessagingDeviceToken())
      .catch((err) => {
        this.snackBar.open('Unable to get permission to notify.', null, {
          duration: 5000
        });
        console.error(err);
      });
  };
}
